import React from 'react';
import { Layout, Drawer } from 'antd';
import { ContainerQuery } from 'react-container-query';
import classNames from 'classnames';
import Footer from './Footer';
import Header from './Header';
import GlobalUIContext from 'context/global-ui-context';
import SiderMenu from 'components/SiderMenu';
import styles from './SiderLayout.module.less';
const { Content } = Layout;

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
    maxWidth: 1599,
  },
  'screen-xxl': {
    minWidth: 1600,
  },
};

class SiderLayout extends React.Component {
  _onLayoutContentClick = (collapsed, toggleMenuCollapse) => () => {
    const { isMobile } = this.props;
    if (isMobile && !collapsed) {
      toggleMenuCollapse();
    }
  };

  render() {
    const { navTheme, children, isMobile, fixedHeader } = this.props;
    const contentStyle = !fixedHeader ? { paddingTop: 0 } : {};
    const layout = (
      <GlobalUIContext.Consumer>
        {context => {
          const { siderMenu } = context;
          const {
            state: { collapsed },
            toggleMenuCollapse,
          } = siderMenu;
          return (
            <Layout>
              {isMobile ? (
                <Drawer
                  placement="left"
                  closable={false}
                  onClose={toggleMenuCollapse}
                  visible={collapsed}
                >
                  <SiderMenu
                    fixSiderbar
                    theme={navTheme}
                    isMobile={isMobile}
                    toggleMenuCollapse={toggleMenuCollapse}
                    width={256}
                    {...this.props}
                  />
                </Drawer>
              ) : (
                <SiderMenu
                  collapsed={collapsed}
                  theme={navTheme}
                  isMobile={isMobile}
                  toggleMenuCollapse={toggleMenuCollapse}
                  width={220}
                  {...this.props}
                />
              )}

              <Layout
                style={{
                  minHeight: '100vh',
                }}
              >
                <Header
                  collapsed={collapsed}
                  toggleMenuCollapse={toggleMenuCollapse}
                  theme={navTheme}
                  isMobile={isMobile}
                  {...this.props}
                />
                <Content className={styles.content} style={contentStyle}>
                  {children}
                </Content>
                <Footer />
              </Layout>
            </Layout>
          );
        }}
      </GlobalUIContext.Consumer>
    );
    return (
      <React.Fragment>
        <ContainerQuery query={query}>
          {params => {
            return <div className={classNames(params)}>{layout}</div>;
          }}
        </ContainerQuery>
      </React.Fragment>
    );
  }
}

export default SiderLayout;
